
// Argon Dashboard 2 MUI layouts
import SignIn from "layouts/authentication/sign-in";
import Horarios from "layouts/horarios";

// Argon Dashboard 2 MUI components
import '@fortawesome/fontawesome-free/css/all.min.css';
import ArgonBox from "components/ArgonBox";
import Honorarios from "layouts/honorarios";
import Perfil from "layouts/perfil";
import SubirComprobante from "layouts/subirComprobante";
import Consultas from "layouts/consultas";
import Ajustes from "layouts/ajustes";
import MiDescripcion from "layouts/miDescripcion";
import CuentaBancaria from "layouts/cuentaBancaria";
import Soporte from "layouts/soporte";


const routes = [
  {
    type: "route",
    name: "Horarios",
    key: "disponibilidad",
    route: "/disponibilidad",
    icon: (
      <ArgonBox component="i" color="#00BCD4" fontSize="14px" className="fa-solid fa-clock" />
    ),
    component: <Horarios />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Consultas",
    key: "ver-disponibilidad",
    route: "/ver-disponibilidad",
    icon: (
      <ArgonBox component="i" color="purple" fontSize="14px" className="fa-solid fa-calendar-days" />
    ),
    component: <Consultas />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Honorarios",
    key: "honorarios",
    route: "/honorarios",
    icon: (
      <ArgonBox component="i" color="green" fontSize="14px" className="fa-solid fa-money-bill" />
    ),
    component: <Honorarios />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Facturas",
    key: "subir-comprobante",
    route: "/subir-comprobante",
    icon: <ArgonBox component="i" color="dark" fontSize="14px" className="fa fa-file-text" />,
    component: <SubirComprobante />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Perfil",
    key: "perfil",
    route: "/perfil",
    icon: (
      <ArgonBox component="i" color="orange" fontSize="14px" className="fa-solid fa-user" />
    ),
    component: <Perfil />,
    includeInSidebar: true,
  },

  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: (
      <ArgonBox component="i" color="warning" fontSize="14px" className="ni ni-single-copy-04" />
    ),
    component: <SignIn />,
    includeInSidebar: false,
  },
  {
    type: "route",
    name: "Ajustes",
    key: "ajustes",
    route: "/ajustes",
    icon: (
      <ArgonBox component="i" color="gray" fontSize="14px" className="fa-solid fa-gear" />
    ),
    component: <Ajustes />,
    includeInSidebar: false,
  },
  {
    type: "route",
    name: "Mi Descripción",
    key: "mi-descripcion",
    route: "/mi-descripcion",
    icon: (
      <ArgonBox component="i" color="blue" fontSize="14px" className="fa-solid fa-edit" />
    ),
    component: <MiDescripcion />,
    includeInSidebar: false,
  },
  {
    type: "route",
    name: "Cuenta Bancaria",
    key: "cuenta-bancaria",
    route: "/cuenta-bancaria",
    icon: (
      <ArgonBox component="i" color="green" fontSize="14px" className="fa-solid fa-university" />
    ),
    component: <CuentaBancaria />,
    includeInSidebar: false,
  },
  {
    type: "route",
    name: "Soporte",
    key: "soporte",
    route: "/soporte",
    icon: (
      <ArgonBox component="i" color="red" fontSize="14px" className="fa-solid fa-headset" />
    ),
    component: <Soporte />,
    includeInSidebar: false,
  }
/*



  {
    type: "route",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-collection" />,
    component: <SignUp />,
  },
  */
];

export default routes;
